<template>
    <div>
        <h1 class="my-5">Forgot password</h1>

        <div v-if="loading"><img src="/loading.svg"> Loading</div>
        <div v-else>
            <div v-if="response == null">
                <p>Enter the email you used to sign up. We will send you a message with password reset instructions.</p>

                <validation-observer ref="observer" v-slot="{ passes }">
                    <form v-on:submit.prevent="passes(requestResetPassword)">
                        <label>Email</label>
                        <validation-provider name="email" rules="email|required" v-slot="{ errors }">
                            <b-form-input type="email" autocomplete="username" v-model="email"></b-form-input>
                            <span class="validation">{{ errors[0] }}</span>
                        </validation-provider>

                        <button type="submit" class="btn btn-success  mt-4">Request new password</button>
                    </form>
                </validation-observer>
            </div>
            <div v-else>
                <p v-html="response"></p>
                <a class="btn btn-sm btn-outline" @click="response = null">Close</a>
            </div>
        </div>

        <p class="text-muted mt-5">Remembered the password? <router-link to="/login">Sign in</router-link>.</p>
    </div>
</template>

<script>
    export default {
        data: () => ({
            email: '',
            loading: false,
            response: null,
        }),
        methods: {
            async requestResetPassword() {
                this.loading = true
                await this.$http.post("/password/reset/send_token",
                    {
                        email: this.email,
                    }
                )
                .then(({data}) => {
                    this.response = data.message;
                })
                .catch(error => { // let the user continue when there are system errors
                    console.log(error)
                    this.response = 'There seems to be a system error. Please reload the page and try again or contact support@boei.help';
                })

                this.loading = false
            },
        }
    }
</script>
